import "./openTicketSingleid.scss";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import {useNavigate, useParams} from "react-router-dom";
import newRequest from "../../../context/newRequest";
import {useEffect, useState} from "react";
import useFetch from "../../../hooks/useFetch";

const OpenTicketSingleID = ({ inputs, title }) => {
  const [ticketOpen, setTicketOpen] = useState({})
  const [categoryId, setCategoryId] = useState(false);
  const [regionId, setRegionId] = useState(["JABODETABEK"]);
  const [sending, setSending] = useState("");
  const [localSite, setLocalSite] = useState({})
  const { siteId } = useParams();
  const user = localStorage.getItem("user");
  const navigate = useNavigate();
  const { data, loading, error } = useFetch(`/localsite/${siteId}`);

  useEffect(() => {
      setLocalSite(data);

  }, [data]);


  const handleSelectRegionID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setRegionId(value);
  };
  const handleSelectCategoryID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setCategoryId(value);
  };



  const handleChange = (e) => {
    setTicketOpen((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      setSending("On Submit")
      const newTicketOpen = {
        ...ticketOpen,
        region_id: regionId[0],
        category_id : categoryId[0]
      };

      const res= await newRequest.post("/ticketlocal/"+siteId, newTicketOpen, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      } );
      setSending("Mengirim Submit")

      const data = res.data.data
      if (res.status == 200) {
        setSending("Submit berhasil")
        navigate(`/ticketsite/${data.id}`);
      }
      console.log(res.status)
    } catch (err) {
      setSending(err.response.data.errors)
      console.log(err.response.data.data);
    }
  };
  return (
      <div className="new">
        <Sidebar />
        <div className="newContainer">
          <Navbar/>
          <div className="top">
            <h1>Open Ticket With Site ID</h1>
          </div>

          <h2>Site Name : {localSite.name_site}</h2>
          <h2>POP ID: {localSite.pop_id}</h2>
          <div className="bottom">


            <div className="right">


              <form>
                <div className="formInput">

                  <label>Vendor ID</label>
                  <input placeholder="Vendor Id" value={ticketOpen.vendor_id} onChange={handleChange}
                         id="vendor_id"/>
                  <label>Root Cause</label>
                  <input placeholder="Root Cause" onChange={handleChange} id="root_cause"/>
                  <label>Action</label>
                  <input placeholder="Action" value={ticketOpen.action} onChange={handleChange}
                         id="action"/>
                  <label className="label">Category ID</label>
                  <select id="region_id" onChange={handleSelectCategoryID}>
                    <option value="">Pilih Category Id</option>
                    <option value="Internal Distribusi Issue">Internal Distribusi Issue</option>
                    <option value="Vendor Device Problem">Vendor Device Problem</option>
                    <option value="Fiber Cut">Fiber Cut</option>
                    <option value="Electrical Issue">Electrical Issue</option>
                    <option value="ONUBAD">ONU Bad</option>
                    <option value="FIBERCUT">Fiber Cut</option>
                    <option value="INTERMITTEN">INTERMITTEN</option>
                    <option value="LOOPING">LOOPING</option>
                    <option value="BENDING">BENDING</option>
                    <option value="ELECTRICAL">ELECTRICAL</option>
                  </select>
                  <label className="label">Region ID default: JABODETABEK</label>
                  <select id="region_id" onChange={handleSelectRegionID}>
                    <option value="">Pilih Region Id</option>
                    <option value="JABODETABEK">JABODETABEK</option>
                    <option value="Jawa Timur">Jawa Timur</option>
                    <option value="lampung">Lampung</option>
                    <option value="Banten">BANTEN</option>
                    <option value="Bali">BALI</option>
                    <option value="sulawesi">Sulawesi</option>
                  </select>

                </div>
              </form>
              <button onClick={handleClick}>Send</button>
            </div>
          </div>
          {sending && <p className="error">{sending}</p>}
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>

        </div>
      </div>
  );
};

export default OpenTicketSingleID;
